module.exports = __webpack_public_path__ + "img/a077ee515a860cfbffd2f2369eb5c99b.png";